import icon1 from '../../../Assets/icon_card_wiseprevent_1.png'
import icon2 from '../../../Assets/icon_card_wiseprevent_2.png'
import icon3 from '../../../Assets/icon_card_wiseprevent_3.png'
import icon4 from '../../../Assets/icon_card_wiseprevent_4.png'
import icon5 from '../../../Assets/icon_card_wiseprevent_5.png'
import icon6 from '../../../Assets/icon_card_wiseprevent_6.png'
import logo from '../../../Assets/fisioteraplay_logo2.png'
import img1 from '../../../Assets/Fisioteraplay _Imagem_1.png'
import img2 from '../../../Assets/Fisioteraplay _Imagem_2.png'
import { HeroSection } from '../Components/HeroSection'
import { CardSection } from '../Components/CardSection'
import { ValueSection } from '../Components/ValueSection'
import { FaqSection } from '../Components/FaqSection'

const CARDS = [
  {
    icon: icon1,
    title: "Jogos Interativos",
    text: "Estimule o movimento e o engajamento dos pacientes com experiências lúdicas.",
  },
  {
    icon: icon2,
    title: "Monitoramento em Tempo Real",
    text: "Acompanhe a evolução do paciente durante as sessões.",
  },
  {
    icon: icon3,
    title: "Relatórios de Desempenho.",
    text: "Acesse indicadores precisos sobre progresso e desempenho motor",
  },
  {
    icon: icon4,
    title: "Compatibilidade de Equipamentos",
    text: "Funciona com esteiras e sensores clínicos variados.",
  },
  {
    icon: icon5,
    title: "Plataforma de Gestão Clínica",
    text: "Gerencie pacientes e sessões em um único sistema.",
  },
  {
    icon: icon6,
    title: "Feedback em Tempo Real",
    text: "Ofereça respostas instantâneas sobre desempenho e postura dos pacientes durante as atividades.",
  },
];

const BLOCKS = [
  {
    title: "Resultados que vão além da operação",
    text:
      `Reabilitação mais eficiente, divertida e com maior engajamento dos pacientes.`,
    bullets: [
      {
        title: "Aumento da adesão ao tratamento.",
        text: ""
      },
      {
        title: "Melhoria dos resultados clínicos.",
        text: ""
      },
      {
        title: "Monitoramento contínuo e detalhado.",
        text: ""
      },
    ],
    img: img2,
  },
];

const FAQ = [
  {
    q: 'A solução é compatível com sensores existentes?',
    a: 'falta a resposta'
  },
  {
    q: 'A solução é compatível com sensores existentes?',
    a: 'Aliquam sit amet odio faucibus, sodales metus placerat, pharetra tortor. Donec ornare urna et tellus rhoncus gravida. Mauris efficitur purus sed ipsum pretium aliquet.'
  },
  {
    q: 'A solução é compatível com sensores existentes?',
    a: 'falta a resposta'
  },
]
export const Fisioteraplay = () => {
  return (
    <div>
      <HeroSection
        logo={logo}
        title='Tecnologia, diversão e movimento a serviço da reabilitação humana'
        text='O FisioTeraPlay transforma sessões de fisioterapia em experiências interativas e motivadoras.'
        colorBtn='--color-3c3c3b'
        url='https://fisioteraplay.com.br/'
        img={img1}
      />

      <CardSection
        cards={CARDS}
        title='Gamificação aplicada à reabilitação motora e cognitiva'
        text='Com o FisioTeraPlay, clínicas e terapeutas aumentam a adesão ao tratamento e aceleram resultados clínicos.'
      />

      <ValueSection
        blocks={BLOCKS}
      />

      {/* <FaqSection
        title="Suas principais dúvidas, respondidas"
        text={[
          'Com a WisePrevent, você reduz custos, prolonga a vida útil dos ativos e tem total controle do que foi feito, por quem e quando.',
          'Tudo rastreável, auditável e pronto para apresentar à gestão ou aos órgãos reguladores.'
        ]}
        colorBtn='--color-ff7022'
        faq={FAQ}
      /> */}

    </div>
  )
}
